import script from "./ProvisioningRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvisioningRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProvisioningRequestModal.vue?vue&type=style&index=0&id=d5024854&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5024854"]])

export default __exports__